import { Address, Coordinates } from '@type-declarations/location';

import { formatAddress } from './formatAddress';

export function getMapsUrl({
  title,
  address,
  coordinates,
}: {
  title?: string;
  address?: Address;
  coordinates?: Coordinates;
}) {
  const titleString = title
    ? `${title}+`
    : address?.title
      ? `${address.title}+`
      : '';

  if (address?.city && address?.street && address?.zipcode) {
    return `https://www.google.com/maps/search/?api=1&query=${titleString}${formatAddress(
      {
        ...address,
        joinChar: '+',
      },
    )}`;
  }

  if (coordinates?.latitude && coordinates?.longitude) {
    return `https://www.google.com/maps?q=${titleString}${coordinates.latitude},${coordinates.longitude}`;
  }

  return `https://www.google.com/maps?q=${titleString}`;
}
